module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('CreateTaskForm', {
    attrs: {
      "user": _vm.user,
      "date": _vm.date,
      "theNewlyCreatedSubject": _vm.theNewlyCreatedSubject,
      "showSubstituteOption": _vm.showSubstituteOption
    },
    on: {
      "setDate": _vm.setDate,
      "close": function($event) {
        return _vm.$emit('close')
      },
      "createNewSubject": function($event) {
        return _vm.setCreateNewSubject($event)
      },
      "onCreatedEvent": _vm.onCreatedEvent
    }
  }), _vm._v(" "), (_vm.theCreateNewSubjectName) ? _c('CreateTaskNewSubject', {
    attrs: {
      "user": _vm.user,
      "date": _vm.date,
      "title": _vm.theCreateNewSubjectName
    },
    on: {
      "newSubject": _vm.onNewSubject,
      "close": function($event) {
        return _vm.setCreateNewSubject(null)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-299effb0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateTask/CreateTask.vue
// module id = 1821
// module chunks = 1